var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('edit-form',{attrs:{"model":_vm.$store.getters['model' + _vm.modelName]},on:{"submit":_vm.save}})}
var staticRenderFns = []

export { render, staticRenderFns }